import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const dotNavigationDefaultVariants = {
  "dotPosition": "inside"
}
const dotNavigationCompoundVariants = []

const dotNavigationSlotNames = [
  [
    "root",
    "DotNavigation__root"
  ],
  [
    "button",
    "DotNavigation__button"
  ],
  [
    "circle",
    "DotNavigation__circle"
  ]
]
const dotNavigationSlotFns = /* @__PURE__ */ dotNavigationSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, dotNavigationDefaultVariants, getSlotCompoundVariant(dotNavigationCompoundVariants, slotName))])

const dotNavigationFn = memo((props = {}) => {
  return Object.fromEntries(dotNavigationSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const dotNavigationVariantKeys = [
  "dotPosition"
]
const getVariantProps = (variants) => ({ ...dotNavigationDefaultVariants, ...compact(variants) })

export const dotNavigation = /* @__PURE__ */ Object.assign(dotNavigationFn, {
  __recipe__: false,
  __name__: 'dotNavigation',
  raw: (props) => props,
  variantKeys: dotNavigationVariantKeys,
  variantMap: {
  "dotPosition": [
    "outside",
    "inside"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, dotNavigationVariantKeys)
  },
  getVariantProps
})